module.exports = new __parcel__URL__("invision.8f2e37e4.png").toString();